export default __webpack_public_path__ + "static/media/intercom.ef3dfd38.png";